import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import FlexContainer from 'components/FlexContainer';
import { IdentificationMethod } from 'redux/types';
import { BankProgressSteps, videoProgressSteps } from './consts';
import {
  CurrentStep,
  NextStep,
  ProgressBarFragment,
  ProgressBarFragmentText,
} from './ProgressBar.styled';
import IProgressBar, { Step } from './types';

const ProgressBar: React.FC<IProgressBar & { intl: IntlShape }> = ({
  step,
  type,
  intl: { formatMessage },
}) => {
  const progressSteps =
    type === IdentificationMethod.IDNOW
      ? videoProgressSteps
      : BankProgressSteps;

  return (
    <FlexContainer
      flexDirection="column"
      width="100%"
      marginBottom="2rem"
      aria-label={formatMessage({ id: 'message.progressBar.label' })}
    >
      <FlexContainer
        justifyContent="space-between"
        alignItems="baseline"
        marginBottom="0.75rem"
      >
        <CurrentStep>
          <FormattedMessage id="message.progressBar.steps.current" />
          <FormattedMessage
            id={`message.progressBar.steps.${progressSteps[step]}`}
          />
        </CurrentStep>
        {step < progressSteps.length - 1 ? (
          <NextStep>
            <FormattedMessage id="message.progressBar.steps.next" />
            <FormattedMessage
              id={`message.progressBar.steps.${progressSteps[step + 1]}`}
            />
          </NextStep>
        ) : null}
      </FlexContainer>
      <FlexContainer
        width="100%"
        justifyContent="space-between"
        padding="0 2px"
      >
        {progressSteps.map((_, i) => (
          <ProgressBarFragment
            key={i}
            index={i as Step}
            currentStep={step as Step}
            style={{ width: Math.floor(100 / progressSteps.length) + '%' }}
            aria-current={i === step ? 'step' : undefined}
          >
            <ProgressBarFragmentText>
              {formatMessage(
                {
                  id: 'message.progressBar.steps.label',
                },
                { index: i + 1, length: progressSteps.length },
              )}
            </ProgressBarFragmentText>
          </ProgressBarFragment>
        ))}
      </FlexContainer>
    </FlexContainer>
  );
};

export default injectIntl(ProgressBar);
